export const titlecase = (text: string) =>
  `${text.charAt(0).toUpperCase()}${text.slice(1)}`;

export const titlecaseSentence = (text: string) =>
  text
    .split(" ")
    .map(part => titlecase(part))
    .join(" ");
